<section class="period-filter">
  <header class="period-filter__header">
    <h2 class="period-filter__title">
      <span class="pi pi-calendar"></span>
      Período
    </h2>

    <div
      class="period-filter__presets"
      role="group"
      aria-label="Períodos rápidos"
    >
      <button
        *ngFor="let preset of presets"
        type="button"
        class="preset"
        [class.preset--active]="activePreset === preset.key"
        [attr.aria-pressed]="activePreset === preset.key"
        (click)="applyPreset(preset.key)"
      >
        {{ preset.label }}
      </button>
    </div>
  </header>

  <div class="period-filter__range">
    <div class="range-field">
      <label [attr.for]="uid + '-start'">De</label>
      <!-- $any em min/maxDate: o p-calendar tipa as propriedades como Date, mas trata undefined como "sem limite". -->
      <p-calendar
        [inputId]="uid + '-start'"
        [(ngModel)]="dataInicial"
        [showIcon]="true"
        dateFormat="dd/mm/yy"
        placeholder="dd/mm/aaaa"
        [maxDate]="$any(today)"
        (ngModelChange)="onStartDateChange($event)"
      ></p-calendar>
    </div>

    <span class="range-separator pi pi-arrow-right" aria-hidden="true"></span>

    <div class="range-field">
      <label [attr.for]="uid + '-end'">Até</label>
      <p-calendar
        [inputId]="uid + '-end'"
        [(ngModel)]="dataFinal"
        [showIcon]="true"
        dateFormat="dd/mm/yy"
        placeholder="dd/mm/aaaa"
        [minDate]="$any(endDateMin)"
        [maxDate]="$any(today)"
        (ngModelChange)="onEndDateChange($event)"
      ></p-calendar>
    </div>

    <button
      type="button"
      class="range-clear"
      [disabled]="!hasPeriod"
      (click)="clear()"
    >
      <span class="pi pi-times"></span>
      Limpar
    </button>
  </div>

  <footer class="period-filter__summary">
    <span class="summary-text">{{ periodLabel }}</span>
    <span class="summary-total">{{ total }} {{ totalLabel }}</span>
  </footer>

  <small class="info period-filter__hint" *ngIf="exportRangeExceeded">
    <span class="pi pi-info-circle"></span>
    A exportação em lote aceita no máximo {{ maxExportRangeInDays }} dias.
  </small>
</section>
